function AgentAdditionalEnrollee() {
    "use strict";

    this.__type = 'AgentAdditionalEnrollee:www.veritracks.com';
    this.Id = -1;
  //  this.AgentId = --1;
    this.Version = 0;

    this.EnrolleeId = -1;
    this.IsActive = true;
    this.TransactionId = '';
    this.UserId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = AgentAdditionalEnrollee;
}